import { useMemo } from 'react'
import { SaleOrder, HoardOrder, Customer, useSaleOperationHooks } from '../../../../sales'
import { WidgetCard } from '../widget-card/widgetCard'
import { RoutePath } from '../../../../../features/routes'
import { formatAmount } from '../../../utils/dashboardUtils'
import styles from './topDebtorsWidget.module.css'

type Props = {
    loading: boolean
    error: boolean
    sales: SaleOrder[]
    hoards: HoardOrder[]
    customers: Customer[]
}

export const TopDebtorsWidget = (props: Props) => {
    const { loading, error, sales, hoards, customers } = props

    const { getCustomersDebt } = useSaleOperationHooks()

    // Mismo cálculo que la Lista de Deudores
    const { topDebtors, skippedCount } = useMemo(() => {
        const { customersDebt, skippedOperations } = getCustomersDebt([...sales, ...hoards], customers)
        const topDebtors = customersDebt
            .slice(0, 5)
            .map(d => ({ customerId: d.customerId, name: d.customer?.name || d.customerId, debt: d.totalDebt }))
        return { topDebtors, skippedCount: skippedOperations.length }
    }, [sales, hoards, customers])

    return (
        <WidgetCard
            title="Top deudores"
            loading={loading}
            error={error}
            empty={!loading && !error && topDebtors.length === 0}
            linkLabel="Ver deudores"
            linkPath={`${RoutePath.CREDIT_ACCOUNTS}/${RoutePath.DEBTS}`}
        >
            <p className="text-muted small mb-2">Incluye cuenta corriente y ventas/acopios con saldo pendiente</p>
            <ul className={styles.list}>
                {topDebtors.map((d, idx) => (
                    <li key={d.customerId} className={styles.item}>
                        <span className={styles.rank}>{idx + 1}</span>
                        <span className={styles.name}>{d.name}</span>
                        <span className={styles.debt}>{formatAmount(d.debt)}</span>
                    </li>
                ))}
            </ul>
            {skippedCount > 0 && (
                <p className="text-muted small mb-0">⚠ {skippedCount} operación(es) no se pudieron calcular (ver consola)</p>
            )}
        </WidgetCard>
    )
}
